import _ from 'lodash';
import { fork, select, takeEvery } from 'redux-saga/effects';
import { isFailedAPIAction } from '../api/HelperAPI';
import { OPEN_ERROR_MODAL } from '../iwModals/Modals.actions';
import {
    isModalLoadedAction,
    serialiseModalErrorData
} from '../iwModals/ModalsHelper';
import { SET_SITE_CONTEXT_READY_DATA } from '../iwSiteContext/IwSiteContext.actions';
import { serialisePaymentErrorData } from '../myAccount/earlyRepayment/confirmRepayment/ConfirmRepaymentHelper';
import { HANDLE_3DS_AUTHENTICATION } from '../myAccount/modals/addPaymentMethodModal/AddPaymentMethodModal.actions';
import { SHOW_PROCESING_PAYMENT_MODAL_ERROR } from '../myAccount/modals/processingPaymentModal/ProcessingPaymentModal.actions';
import { isPageLoadedAction } from '../myAccount/pageStructure/routerWorkers/PageHelper';
import * as IwDataDogLogger from './IwDataDogLogger';

export const errorSagaWorkers = [
    fork(APIErrorWorker),
    fork(ModalErrorWorker),
    fork(SiteContextWorker),
    fork(RepaymentErrorWorker),
    forkEveryInfo(isPageLoadedAction, 'page_loaded_saga'),
    forkEveryInfo(isModalLoadedAction, 'modal_loaded_saga'),
    forkEveryInfo(HANDLE_3DS_AUTHENTICATION, '3DS_authentication_saga')
];

function forkEveryInfo(checkAction, reporter) {
    return fork(function* () {
        yield takeEvery(checkAction, function* (action) {
            const siteContext = yield select(({ siteContext }) => siteContext);

            yield IwDataDogLogger.logInfo(action.type, {
                tags: {
                    reporter: reporter,
                    impersonating: siteContext.impersonating,
                    stateKey: siteContext.impersonatingStateKey
                }
            });
        });
    });
}

function* RepaymentErrorWorker() {
    yield takeEvery(SHOW_PROCESING_PAYMENT_MODAL_ERROR, function* (action) {
        const error = serialisePaymentErrorData(action);
        const siteContext = yield select(({ siteContext }) => siteContext);

        yield IwDataDogLogger.logError(`${action.type}`, {
            tags: {
                reporter: 'repayment_saga',
                impersonating: siteContext.impersonating,
                stateKey: siteContext.impersonatingStateKey
            },
            error
        });
    });
}

function* APIErrorWorker() {
    yield takeEvery(isFailedAPIAction, function* (action) {
        const siteContext = yield select(({ siteContext }) => siteContext);

        yield IwDataDogLogger.logError(`${action.type}`, {
            tags: {
                reporter: 'api_saga',
                impersonating: siteContext.impersonating,
                stateKey: siteContext.impersonatingStateKey
            },
            data: _.get(action, 'response.data'),
            meta: _.get(action, 'response.meta')
        });
    });
}

function* ModalErrorWorker() {
    yield takeEvery(OPEN_ERROR_MODAL, function* (action) {
        const error = serialiseModalErrorData(action);
        const siteContext = yield select(({ siteContext }) => siteContext);

        yield IwDataDogLogger.logError(
            `${action.type} id=${_.get(action, 'id')}`,
            {
                tags: {
                    reporter: 'modal_saga',
                    impersonating: siteContext.impersonating,
                    stateKey: siteContext.impersonatingStateKey
                },
                error
            }
        );
    });
}

function* SiteContextWorker() {
    yield takeEvery(SET_SITE_CONTEXT_READY_DATA, function* (action) {
        const siteContext = yield select(({ siteContext }) => siteContext);

        yield IwDataDogLogger.identifyUser({
            state_key: _.get(action, 'data.state_key'),
            impersonating: siteContext.impersonating
        });
    });
}
